// Zod schemas for the shared chart/stat primitives in @/api/types.
// Task [2.4]'s per-domain real fetchers compose these to .parse() a real API
// response before returning it, so a backend shape drift fails loud at the
// fetch boundary instead of surfacing as a render-time undefined deep in a chart.

import { z } from 'zod';

export const trendDirectionSchema = z.enum(['up', 'down', 'flat']);

export const statTileSchema = z.object({
	id: z.string(),
	label: z.string(),
	value: z.string(),
	deltaPct: z.number().optional(),
	trend: trendDirectionSchema.optional(),
});

export const barDatumSchema = z.object({
	label: z.string(),
	value: z.number(),
});

export const donutDatumSchema = z.object({
	name: z.string(),
	value: z.number(),
});

export const linePointSchema = z.object({
	date: z.string(),
	value: z.number(),
});

export const groupedBarDatumSchema = z.object({
	label: z.string(),
	delivered: z.number(),
	failed: z.number(),
	pending: z.number(),
});
